/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import PlusSvg from 'images/v5/icons/plus.svg';
import styles from './Accordion.module.scss';
function Accordion({ opened = false, onClick = null, header = null, specHeader = null, noBorder = false, children, }) {
    var _a;
    const [isOpening, setIsOpening] = useState(false);
    const [isOpened, setIsOpened] = useState(false);
    const childRef = useRef(null);
    useEffect(() => {
        setIsOpening(opened);
        let timeoutId = null;
        if (opened) {
            timeoutId = setTimeout(() => {
                setIsOpened(true);
            }, 300);
        }
        else {
            setIsOpened(false);
        }
        // Cleanup function to cancel the timeout if component unmounts
        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [opened]);
    const handleHeaderClick = () => {
        if (onClick) {
            onClick();
        }
        else {
            setIsOpening(!isOpening);
        }
    };
    return (React.createElement(React.Fragment, null,
        header && (React.createElement("div", { className: styles.header, onClick: handleHeaderClick }, header)),
        specHeader && (React.createElement("div", { className: classNames(styles.specHeader, {
                [styles.noBorder]: noBorder,
                [styles.opened]: opened,
            }), onClick: handleHeaderClick },
            specHeader,
            React.createElement(PlusSvg, null))),
        React.createElement("div", { className: classNames(styles.content, {
                [styles.opened]: isOpened,
                [styles.bordered]: specHeader,
            }), style: { height: isOpening ? (_a = childRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight : 0 } },
            React.createElement("div", { className: styles.contentChild, ref: childRef }, children))));
}
export default Accordion;
